import { BsChevronCompactDown, BsFillArrowDownCircleFill } from "react-icons/bs";
import Skeleton from "react-loading-skeleton";
import { IDocumento } from "../../../../@interfaces";
import { IDocsProps } from "../../../../@interfaces/docFuncionario";
import BotaoFiltrar from "../../../../components/botaofiltrar";
import DocItem from "../../../../components/docItem";
import DocView from "../../../../components/docview";
import MensagemListaVazia from "../../../../components/mensagemlistavazia";
import Options from "../../../../components/select/options";
import { BotaoEmpresa, CheckLabel, CheckOption, Container, ContainerSelecao, DocList, DownloadSelectedFilesButton, DropDown, EmpresasContainer, FilterContainer, InputContainer, InputDate, LinhaSkeleton, TituloAgrupamento } from "./styles";
import useDocs from "./useDocs";
import Subtitle from "../../../../components/subtitle";
import Text from "../../../../components/text";
import Title from "../../../../components/title";
import { IoChevronDown } from "react-icons/io5";
import useIsMobile from "../../../../hooks/useIsMobile";




const Docs: React.FC<IDocsProps> = (props) => {

  const {
    buscaDisponivel,
    filtrosAtuais,
    filtroAberto,
    colors,
    todosSelecionados,
    carregando,
    acaoCarregando,
    documentoAberto,
    modalDocumentoAberto,
    empresasDisponiveis,
    empresaSelecionada,
    alocacoes,
    statusAssinatura,
    documentosSelecionados,
    tiposDocumento,
    tipoSelecionado,
    mostrarLista,
    listaAgrupada,
    opcoes,
    apiAntiga,
    carregarDocumentos,
    selecionarEmpresa,
    abrirDocumento,
    fecharDocumento,
    baixarArquivo,
    baixarArquivosSelecionados,
    atualizarValoresFiltros,
    abrirOpcoes,
    fecharOpcoes,
    marcarDocumento,
    marcarTodosDocumentos,

  } = useDocs(props);


  function Placeholder() {
    return (
      <>
        <Skeleton height={20} width={'20%'} style={{ marginBottom: 30 }} />

        {Array(1).fill(0).map((item, index) => (
          <>
            <Skeleton height={20} width={'10%'} key={index} />
            <LinhaSkeleton key={index}>
              {Array(4).fill(0).map((item, index) => <Skeleton height={40} key={index} />)}
            </LinhaSkeleton>
          </>
        ))}
      </>
    )
  }

  const isMobile = useIsMobile();

  return (
    <Container paddingLateral={0}>

      {modalDocumentoAberto && <DocView file={documentoAberto} closeView={fecharDocumento} />}

      {!!filtroAberto &&
        <Options close={fecharOpcoes} selectOption={valor => atualizarValoresFiltros(valor, filtroAberto)} itens={opcoes[filtroAberto]} />}


      <>
        {!!tiposDocumento &&
          <FilterContainer >
            {/* <a onClick={openFilterModal}>
              <FaFilter color={colors.halfOpacityBlack} style={{ marginTop: 3 }} />
              <label>Filtros</label>
            </a> */}
            <div className="flex gap-5 max-[660px]:flex-col max-[660px]:w-full">
              <InputContainer>
                <Subtitle className="!text-[.75rem] !text-[rgba(0,0,0,.6)]">Tipo de documento</Subtitle>
                <DropDown onClick={() => abrirOpcoes('tipoDocumento')}>
                  <Text className="!overflow-ellipsis !overflow-hidden !whitespace-nowrap !text-[rgba(0,0,0,.5)]">
                    {filtrosAtuais?.tipoDocumento !== null ? tipoSelecionado?.label : 'Escolha o tipo de documento'}
                  </Text>
                  <IoChevronDown size={12} />
                </DropDown>

              </InputContainer>


              <InputContainer>
                <Subtitle className="!text-[.75rem] !text-[rgba(0,0,0,.6)]">{"Período"}</Subtitle>
                <div className="row w-full">
                  <div className="relative w-full">
                    <InputDate
                      type={"date"}
                      onChange={e => atualizarValoresFiltros(e.target.value, 'dataInicial')}
                      max={filtrosAtuais?.dataFinal || "9999-12-31"}
                      value={filtrosAtuais?.dataInicial}
                      disabled={carregando}
                    />
                    <IoChevronDown size={12} className="text-[rgba(0,0,0,0.5)] absolute right-[6px] top-[50%] translate-y-[-50%] pointer-events-none" />
                  </div>
                  <><span>-</span>
                    <div className="relative w-full">
                      <InputDate
                        type={'date'}
                        value={filtrosAtuais?.dataFinal}
                        onChange={event => atualizarValoresFiltros(event.target.value, 'dataFinal')}
                        max={"9999-12-31"}
                        min={filtrosAtuais?.dataInicial}
                        disabled={carregando}
                      />
                      <IoChevronDown size={12} className="text-[rgba(0,0,0,0.5)] absolute right-[6px] top-[50%] translate-y-[-50%] pointer-events-none" />
                    </div>
                  </>
                </div>
              </InputContainer>
            </div>



            <div className={`flex w-full max-[660px]:flex-col ${filtrosAtuais?.tipoDocumento === 1 && 'gap-5'}`}>
              <div className="flex gap-5">
                {apiAntiga && filtrosAtuais?.tipoDocumento === 1 &&
                  <>
                    <InputContainer>
                      <Subtitle className="!text-[.75rem] !text-[rgba(0,0,0,.6)]">Tipo de alocação</Subtitle>
                      <DropDown onClick={() => abrirOpcoes('alocacao')}>
                        <Text className="!overflow-ellipsis !overflow-hidden !whitespace-nowrap !text-[rgba(0,0,0,.5)]">{!!filtrosAtuais?.alocacao ? alocacoes?.find(item => item.value === filtrosAtuais.alocacao)?.label : "Todos"}</Text>
                        <BsChevronCompactDown />
                      </DropDown>
                    </InputContainer>


                  </>
                }


                {!apiAntiga || filtrosAtuais?.tipoDocumento === 1 && <InputContainer>
                  <Subtitle className="!text-[.75rem] !text-[rgba(0,0,0,.6)]">Situação de Assinatura</Subtitle>
                  <DropDown onClick={() => abrirOpcoes('assinatura')}>
                    <Text className="!overflow-ellipsis !overflow-hidden !whitespace-nowrap !text-[rgba(0,0,0,.5)]">{!!filtrosAtuais?.assinatura ? statusAssinatura?.find(item => item.value === filtrosAtuais.assinatura)?.label : "Todos"}</Text>
                    <BsChevronCompactDown />
                  </DropDown>
                </InputContainer>}
              </div>

              {buscaDisponivel && <BotaoFiltrar className="!self-end" loading={carregando} onClick={carregarDocumentos}>Buscar</BotaoFiltrar>}
            </div>

          </FilterContainer >
        }


        <EmpresasContainer>
          {empresasDisponiveis?.map(item =>
            <BotaoEmpresa selecionado={empresaSelecionada === item.empresa} onClick={() => selecionarEmpresa(item.empresa)}>
              {item.nome}
            </BotaoEmpresa>
          )}
        </EmpresasContainer>
      </>

      {!carregando && mostrarLista &&
        <>
          <ContainerSelecao selecionarTodos={todosSelecionados}>
            <CheckOption>
              <input className="cursor-pointer"
                type={"checkbox"}
                id="select_all"
                checked={todosSelecionados}
                onChange={event => marcarTodosDocumentos(event.target.checked)}
              />
              <CheckLabel
                htmlFor="select_all"
                style={{ color: todosSelecionados ? colors.white : colors.halfOpacityBlack }}
              >
                Selecionar todos
              </CheckLabel>
            </CheckOption>

            {documentosSelecionados.length > 0 &&
              <DownloadSelectedFilesButton onClick={baixarArquivosSelecionados}>
                <Text className={`!w-fit !text-end !text-[.9rem] !font-semibold ${todosSelecionados ? '!text-white' : '!text-[rgba(0,0,0,.5)]'}`}>{isMobile ? 'Baixar selecionados' : 'Baixar documentos selecionados'}</Text>
                <BsFillArrowDownCircleFill size={16} color={todosSelecionados ? colors.white : colors.halfOpacityBlack} style={{ marginBottom: 2 }} />
              </DownloadSelectedFilesButton>
            }

          </ContainerSelecao>
          <DocList>

            {listaAgrupada!.map(item => (
              <>
                <Title className="!my-4">{item.tipo}</Title>
                <ul style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {item.documentos.map((documento: IDocumento) => (
                    <DocItem
                      documento={documento}
                      documentosSelecionados={documentosSelecionados}
                      selecionarDocumento={marcarDocumento}
                      abrirDocumento={abrirDocumento}
                      baixarArquivo={baixarArquivo}
                      acaoCarregando={acaoCarregando}
                    />
                  ))}
                </ul>
              </>
            ))}

          </DocList>
        </>}


      {
        !mostrarLista && !carregando &&
        <MensagemListaVazia
          texto={'Filtre para buscar documentos'}
          textoSecundario={'Não há dados a serem mostrados'}
        />
      }



      {carregando && <Placeholder />}

    </Container >
  )
}



export default Docs;